module.exports = __webpack_public_path__ + "img/carousel-3-1.05e4cd3b.jpg";